export default __webpack_public_path__ + "static/media/seiseki5.751fc842.png";